import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { isSafePathSegment, isTrustedRedirect } from 'app/modules/shared/utils/third-party-data';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlShortenedService } from 'app/core/api/url-shortened.service';
import { UrlShortened } from 'app/modules/shared/models/url-shortend.model';
import { EmergencyAgentAccessService } from '../overview/emergency/emergency-agent-access/emergency-agent-access.service';
import { WifiSettingsService } from 'app/core/api/wifi-settings.service';
import { tokenFromUrl, wifiTokenFromUrl, wifiTokenToFragment } from 'app/modules/shared/utils/third-party-data';

@Component({
    selector: 'url-shortened',
    templateUrl: './url-shortened.component.html',
    styleUrls: ['./url-shortened.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UrlShortenedEaaComponent implements OnInit {
    code = '';
    isLoading = true;
    urlShortened = new UrlShortened();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private urlShortenedService: UrlShortenedService,
        private emergencyAgentAccessService: EmergencyAgentAccessService,
        private wifiSettings: WifiSettingsService
    ) {}

    ngOnInit(): void {
        this.code = this.route.snapshot.params['code'];

        // The code comes from the address bar and goes into an API path (BSI O.Source_1)
        if (!isSafePathSegment(this.code)) {
            this.isLoading = false;
            this.router.navigate(['404']);
            return;
        }

        this.urlShortenedService.findByCode(this.code).subscribe((received) => {
            this.isLoading = false;
            this.urlShortened = received;
            if (this.urlShortened.urlOriginal) {
                // eaa
                if (this.urlShortened.urlOriginal.includes('eaa')) {
                    // The link comes from outside the app: the token has to be well-formed (BSI O.TrdP_7);
                    // it is in the fragment ("#eaa=") of new links and in the query of earlier ones
                    const eaaToken = tokenFromUrl(this.urlShortened.urlOriginal, 'eaa');
                    if (eaaToken) {
                        this.emergencyAgentAccessService.setEaaTokenSubject(
                            eaaToken
                        );
                        const randomValue = Math.random()
                            .toString(36)
                            .substring(6);
                        this.router.navigate(
                            ['emergency-center-agent-access'],
                            {
                                queryParams: { v: randomValue },
                                fragment: `eaa=${encodeURIComponent(eaaToken)}`,
                            }
                        );
                    }
                }
                // wst
                if (this.urlShortened.urlOriginal.includes('wst')) {
                    // the token is in the fragment ("#wst=") of new links and in the query of older ones
                    const wstToken = wifiTokenFromUrl(this.urlShortened.urlOriginal);
                    if (wstToken) {
                        this.wifiSettings
                            .isValidWifiSettingsToken(wstToken)
                            .subscribe(
                                (res) => {
                                    if (res?.valid === true) {
                                        // const randomValue = Math.random().toString(36).substring(6);
                                        // this.router.navigate(['wifi-settings'], { queryParams: { wst: wstToken, v: randomValue } });
                                        if (
                                            window.location.pathname.includes(
                                                'http://localhost:4200'
                                            )
                                        ) {
                                            this.urlShortened.urlOriginal =
                                                this.urlShortened?.urlOriginal?.replace(
                                                    'https://adele.test.almaphil.de',
                                                    'http://localhost:4200'
                                                );
                                        }
                                        // the target comes from the backend: send the browser only to our own addresses;
                                        // the token goes in the fragment, so the next request does not carry it
                                        const target = wifiTokenToFragment(
                                            this.urlShortened.urlOriginal
                                        );
                                        window.location.href = isTrustedRedirect(
                                            target,
                                            window.location.origin
                                        )
                                            ? target
                                            : '/';
                                    } else {
                                        window.location.href = '/';
                                    }
                                },
                                (err) => {
                                    window.location.href = '/';
                                }
                            );
                    }
                }
            }
        });
    }
}
